import { useRef } from "react";
import SyInput from "../../forms/sy-input-form";
import styleSheet from "./style.module.scss";
import { AvatharProps } from "./orb-avatar-interface";
import SyIcon from "../sy-icon";
import { CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";
import { getImageDetails } from "../../../feature/image-slice";

const OrbAvatar = (props: AvatharProps) => {
  const {
    file,
    className = `${styleSheet.avatar}`,
    online,
    fileUpload = false,
    onChanceVal,
  } = props;
  const inputRef = useRef<HTMLInputElement>(null);
  const imageDetails = useSelector(getImageDetails);
  const handleImageClick = () => {
    if (fileUpload) {
      inputRef.current?.click();
    }
  };
  const handleDeleteClick = () => {
    if (onChanceVal) {
      // Simulate clearing the file
      onChanceVal(null);
    }
  };
  

  return (
    <div className="position-relative">
      <img
        className={`${className} object-fit-cover rounded-circle `}
        src={file || imageDetails.default[0].img}

        alt=""
      />
      {/* {online !== undefined && (
        <div
          className={` position-absolute bottom-0 end-0 rounded-circle w-25 h-25 ${
            online ? "bg-success" : "bg-secondary"
          }`}
        ></div>
      )} */}
      {fileUpload && (
        <div
          className={` position-absolute bottom-0 end-0 d-flex align-items-center   pointer`} >
            {file?(
               <SyIcon name={"delete"} className={" rounded-circle font-15 bg-white p-1"}  onClick={handleDeleteClick}/> 
            
            ):(
            <SyIcon name={"camera_alt"} className={" rounded-circle font-15 bg-white p-1"}  onClick={handleImageClick}/>
            )}
               {/* <CircularProgress size="1rem" /> */}
        </div>
      )}
      <SyInput
        type="file"
        ref={inputRef}
        className="d-none"
        onChange={onChanceVal}
      />
    </div>
  );
};

export default OrbAvatar;
